module.exports = __webpack_public_path__ + "img/logo1234yi.1dfdaf54.jpg";